import { DEFAULT_LANG } from '@/constants/lang'

export const CURRENT_LANG = (() => {
  const matchLang = /account\/([a-zA-Z-]{2,5})\//.exec(window.location.href)
  return matchLang ? matchLang[1] : DEFAULT_LANG
})()
